import { IChatServerService } from '@/app-modules/server-service';
import { IUserSearchService, UserSearchService } from '@/components/chat/_domain/modules/user-search-service/user-search-service';
import { injectable, inject } from 'inversify';
import { IConfigurationService } from '@/app-modules/config';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';

interface IUserSearchServiceFactory {
  getUserSearchService(server: IChatServerService): IUserSearchService;
}

@injectable()
class UserSearchServiceFactory implements IUserSearchServiceFactory {
  constructor(@inject(SERVICE_IDENTIFIERS.IConfigurationService) private readonly configurationService: IConfigurationService) {
  }

  public getUserSearchService(server: IChatServerService): IUserSearchService {
    return new UserSearchService(server, this.configurationService);
  }
}

export { IUserSearchServiceFactory, UserSearchServiceFactory };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/user-search-service/user-search-service-factory.ts